<template>
  <v-dialog v-model="visible" max-width="650" scrollable>
    <v-card class="rounded-xl overflow-hidden">
      <!-- Cabecera con alerta visual -->
      <v-card-title
        class="amber darken-3 white--text py-3 px-5 d-flex align-center justify-space-between"
      >
        <div class="d-flex align-center">
          <v-icon color="white" class="mr-2" size="26"
            >mdi-alert-octagon-outline</v-icon
          >
          <div>
            <div class="text-subtitle-1 font-weight-bold">
              Registro de Faltas y Amonestaciones
            </div>
            <div class="text-caption" style="color: rgba(255, 255, 255, 0.85)">
              Antecedentes laborales registrados en Recursos Humanos
            </div>
          </div>
        </div>
        <v-btn icon small dark @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="pa-5" style="max-height: 520px">
        <!-- Información del Postulante -->
        <div
          class="d-flex align-center justify-space-between pa-3 mb-4 rounded-lg bg-light-grey border"
        >
          <div>
            <div class="text-caption grey--text text--darken-1">
              Postulante / Trabajador:
            </div>
            <div
              class="text-subtitle-2 font-weight-bold text-truncate"
              style="max-width: 320px"
            >
              {{ applicant?.FullName || applicant?.WkrName || "Sin Nombre" }}
            </div>
          </div>
          <div class="text-right">
            <div class="text-caption grey--text text--darken-1">
              N° Documento (DNI):
            </div>
            <div class="text-subtitle-2 font-weight-bold teal--text">
              {{
                applicant?.PrsDocumentNumber ||
                applicant?.AdmDocumentNumber ||
                "-"
              }}
            </div>
          </div>
        </div>

        <!-- Alerta descriptiva -->
        <v-alert
          dense
          outlined
          type="warning"
          class="mb-4 text-caption rounded-lg"
          border="left"
        >
          Este postulante cuenta con amonestaciones previas en la empresa.
          Revise el detalle de la falta y sustento antes de continuar el proceso
          de contratación.
        </v-alert>

        <!-- Detalle de la Falta / Amonestación -->
        <div v-if="parsedAdmonition" class="admonition-details">
          <v-card
            outlined
            class="pa-4 rounded-xl mb-3 border elevation-0"
            style="border-left: 4px solid #f57c00 !important"
          >
            <div class="d-flex justify-space-between align-center mb-2">
              <v-chip
                color="amber darken-4"
                dark
                small
                class="font-weight-bold"
              >
                <v-icon left x-small>mdi-gavel</v-icon>
                {{ parsedAdmonition.TypeAdmonitionText || "Amonestación" }}
              </v-chip>
              <span class="text-caption grey--text text--darken-1">
                Fecha: <strong>{{ parsedAdmonition.AdmDate || "-" }}</strong>
              </span>
            </div>

            <!-- Falta / Descripción -->
            <div class="mb-3 mt-2">
              <span
                class="text-caption font-weight-bold red--text text--darken-3 d-block mb-1"
              >
                <v-icon x-small color="red darken-3" class="mr-1"
                  >mdi-alert-circle</v-icon
                >
                DESCRIPCIÓN DE LA FALTA:
              </span>
              <div
                class="pa-3 rounded-lg bg-fault text-body-2 font-weight-medium"
              >
                {{
                  parsedAdmonition.AdmObservation ||
                  "Sin descripción de falta registrada."
                }}
              </div>
            </div>

            <!-- Sustento -->
            <div class="mb-3" v-if="parsedAdmonition.AdmReason">
              <span
                class="text-caption font-weight-bold grey--text text--darken-2 d-block mb-1"
              >
                <v-icon x-small color="grey darken-2" class="mr-1"
                  >mdi-file-document-outline</v-icon
                >
                SUSTENTO / MOTIVO:
              </span>
              <div class="pa-3 rounded-lg bg-light-grey text-caption">
                {{ parsedAdmonition.AdmReason }}
              </div>
            </div>

            <!-- Fechas de Suspensión -->
            <!-- <div
              v-if="parsedAdmonition.AdmDateStart || parsedAdmonition.AdmDateFinish"
              class="d-flex align-center pa-2 rounded-lg bg-light-amber border text-caption"
            >
              <v-icon small color="amber darken-3" class="mr-2">mdi-calendar-clock</v-icon>
              <span>
                Periodo de Suspensión:
                <strong>{{ parsedAdmonition.AdmDateStart || "-" }}</strong> hasta
                <strong>{{ parsedAdmonition.AdmDateFinish || "-" }}</strong>
              </span>
            </div> -->
          </v-card>
        </div>

        <div v-else class="text-center py-6 grey--text">
          <v-icon size="40" color="grey lighten-1"
            >mdi-information-outline</v-icon
          >
          <p class="text-caption mt-2">
            No se encontró información detallada de la amonestación.
          </p>
        </div>
      </v-card-text>

      <v-divider />

      <v-card-actions class="pa-4 bg-light-grey">
        <v-spacer />
        <v-btn
          color="grey darken-2"
          text
          rounded
          class="px-5 font-weight-bold"
          @click="close"
        >
          Cerrar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "HmnAdmonitionDetailDialog",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    applicant: {
      type: Object,
      default: null,
    },
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    parsedAdmonition() {
      if (!this.applicant) return null;
      if (this.applicant.AdmonitionDetailJSON) {
        try {
          if (typeof this.applicant.AdmonitionDetailJSON === "string") {
            return JSON.parse(this.applicant.AdmonitionDetailJSON);
          }
          return this.applicant.AdmonitionDetailJSON;
        } catch (e) {
          console.error("Error parsing AdmonitionDetailJSON:", e);
        }
      }
      if (
        this.applicant.AdmObservation ||
        this.applicant.TypeAdmonitionText ||
        this.applicant.TypeAdmonitionName
      ) {
        return {
          TypeAdmonitionText:
            this.applicant.TypeAdmonitionText ||
            this.applicant.TypeAdmonitionName,
          AdmObservation: this.applicant.AdmObservation,
          AdmReason: this.applicant.AdmReason,
          AdmDate: this.applicant.AdmDate,
          AdmDateStart: this.applicant.AdmDateStart,
          AdmDateFinish: this.applicant.AdmDateFinish,
        };
      }
      return null;
    },
  },
  methods: {
    close() {
      this.visible = false;
    },
  },
};
</script>

<style scoped>
.bg-light-grey {
  background-color: #f8fafc;
}
.bg-fault {
  background-color: #fff5f5;
  border: 1px solid #fed7d7;
  color: #742a2a;
}
.bg-light-amber {
  background-color: #fffbeb;
  border: 1px solid #fef3c7;
}
</style>
